<template>
  <div v-if=" data.id ">
    <table class="table __type__hrz __type__input">
      <tbody>
          <tr>
              <th class="wdt-120em">上代</th>
              <td>
                  <p>
                      <span class="form-value">{{ data.retail_price | currency }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>下代</th>
              <td>
                  <p>
                      <span class="form-value">{{ data.wholesale_price | currency }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>原価</th>
              <td>
                  <p>
                      <span class="form-value">{{ data.cost | currency }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>資材・キャンドル</th>
              <td>
                  <p v-if="data.material_price">
                      <span class="form-value">{{ data.material_price | currency }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>磨き・レンタル代</th>
              <td>
                  <p v-if="data.rental_price">
                      <span class="form-value">{{ data.rental_price | currency }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
          <tr>
              <th>生花仕入代（計）</th>
              <td>
                  <p>
                      <span class="form-value">{{ total() }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>

          <tr v-for="n in 10" v-if="item(n)">
              <th>花材</th>
              <td>
                  <p>
                      <span class="form-value">{{ item(n) }}</span>
                  </p>
                  <p>
                      <span class="form-value">{{ price(n) }}</span>
                      <span class="form-text">円</span>
                      <span class="form-text">×</span>
                      <span class="form-value">{{ unit(n) }}</span>
                      <span class="form-text">本</span>
                      <span class="form-text">＝</span>
                      <span class="form-value">{{ subtotal(n) }}</span>
                      <span class="form-text">円</span>
                  </p>
              </td>
          </tr>
      </tbody>
    </table>

  </div>

  <div v-else>
    回答がありません
  </div>
</template>

<script>

  export default {

    props: {
      data: {type: Object},
    },

    filters: {
      currency: function (str) {
        return str?str.toLocaleString():'';
      },
    },

    methods: {
      item: function(i){
        return eval('this.data.item' + i);
      },
      price: function(i){
        var ret = (eval('this.data.price' + i) + '').replace(/,/g, '');
        return ret.toLocaleString() || '';
      },
      unit: function(i){
        var ret = (eval('this.data.unit' + i) + '').replace(/,/g, '');
        return ret.toLocaleString() || '';
      },
      subtotal: function(i){
        var unit = eval('this.data.unit' + i) + '';
        var price = eval('this.data.price' + i) + '';
        var ret = parseInt(unit.replace(/,/g, '')) * parseInt(price.replace(/,/g, ''));
        return ret.toLocaleString() || '';
      },
      total: function(){
        var ret = 0;
        for(let i=1; i < 11; i++){
          ret += parseInt(this.subtotal(i).replace(/,/g, '')) || 0;
        }
        return ret.toLocaleString() || '';
      },
    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PricecheckText.vue